interface CardContentProps {
  image: string;
  title: string;
  description: string;
  buttons: JSX.Element;
}

export const CardContent = (props: CardContentProps) => {
  return (
    <div className="flex flex-col items-center">
      <img
        src={props.image}
        className="w-full object-cover h-96 rounded-xl"
        alt={props.title}
      />

      <h2 className="py-5 self-start font-bold text-3xl">{props.title}</h2>
      <p className="px-8 self-start text-justify text-font-semibold ">
        {props.description}
      </p>

      <div className="flex justify-center gap-5 mt-5">{props.buttons}</div>
    </div>
  );
};
